export default {
  '847ef1be8c5c20ddf71c2b8156c22dbf': '提示',
  c694fdd9779381317352b6e1ed03267d: '暂不解绑',
  f510e72ea1ba87e3f7ed5600830272cc: '解绑账号',
  '4f4309e2c1e3390d19259e3523ec04d8':
    '根据国家政策要求，发往台湾地区的快件需填写证件号码，请您补充填写',
  d4a6b6cff9ce229a3caa981e66786528: '取消',
  d32275e7d418ae7ed2945adedc040ec7: '去补充',
  '596ccc86ae49ea544182222542c3b54f': '抱歉，价格已发生变化!',
  b4ae53838c0e0f8eb3a3497fe4a8e8a9: '抱歉，创建订单失败！',
  '381b884bbcb1d33eccd70e3b19ee595a': '系统错误',
  '6fad4422b2105c2f7e5382aa64a49e6a': '内购商品已失效',
  '6fad4422b2105c2f7e5382aa64a49e6b': '支付成功'
};
